import type { FC } from "react";
import styled from "styled-components";
import { translate } from "app/filters/i18nFilter";
import { MetricData } from "@similarweb/ui-components";
import { LoaderContainer, LoadingSpinner } from "app/pages/keyword-analysis/TotalTrafficPage/StyledComponents";

const TotalVisitsWrapper = styled.div`
    text-align: center;
`;

interface ITotalVisits {
    absolute: string;
    change: string;
    isDecrease: boolean;
    isLoading?: boolean;
}

const TotalVisits: FC<ITotalVisits> = ({ absolute, change, isDecrease, isLoading }) => {
    return (
        <TotalVisitsWrapper data-automation="TotalVisits">
            {isLoading ? (
                <LoaderContainer>
                    <LoadingSpinner />
                </LoaderContainer>
            ) : (
                <MetricData
                    metricNameProps={{
                        displayName: translate("industryoverview.key.indicators.total.visits.display.name"),
                    }}
                    valueProps={{ displayValue: absolute }}
                    changeProps={{ value: change, isDecrease: isDecrease }}
                />
            )}
        </TotalVisitsWrapper>
    );
};

export default TotalVisits;
